const RestEndPoints = {
  HOLDINGS_PATH: '/portfolio/holdings',
  POSITION_BOOK_PATH: '/portfolio/positions',
  TRADE_BOOK_PATH: '/orders/trades',
  PROFILE_PATH: '/user/profile',
  ORDERS_PATH: '/orders'
};

export default RestEndPoints;
